var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { buildDevProps } from '../../helpers/builders';
var builderDefaultProps = function (theme, multiSelect) {
    var labelProps = {
        fontWeight: 'bold',
        type: 'p2',
        color: theme.neutrals.gray8,
        pBottom: 'nano',
    };
    var wrapperProps = {
        bRadius: 'xs',
        bWidth: 'hairline',
        bColor: theme.neutrals.gray4,
        bgColor: theme.neutrals.pureWhite,
        pLeft: !multiSelect ? 'xxxs' : 'nano',
        pRight: 'nano',
    };
    var containerProps = {
        fontSize: 'xxs',
        fontWeight: 'medium',
    };
    var dropdownContainerProps = {
        bRadius: 'xs',
        bWidth: 'hairline',
        bColor: theme.neutrals.gray4,
        bgColor: theme.neutrals.pureWhite,
        mTop: 'nano',
        px: 'nano',
        py: 'nano',
    };
    var dropdownItemProps = {
        px: 'nano',
        py: 'nano',
        mBottom: 'quark',
        bgColor: theme.neutrals.pureWhite,
        bRadius: 'xs',
    };
    var dropdownItemTypographyProps = {
        type: 'p2',
        fontSize: 'xxs',
        fontWeight: 'medium',
        color: theme.neutrals.gray7,
    };
    var dropdownSectionProps = {
        pTop: 'nano',
        px: 'nano',
        bgColor: theme.neutrals.pureWhite,
        bRadius: 'xs',
    };
    var dropdownSectionTypographyProps = {
        type: 'p2',
        fontSize: 'xxs',
        fontWeight: 'bold',
        color: theme.neutrals.gray7,
    };
    var helperTextTypographyProps = {
        type: 'p2',
        mTop: 'nano',
        textAlign: 'left',
        color: theme.neutrals.gray5,
        fontSize: 'xxxs',
        fontWeight: 'bold',
    };
    return {
        labelProps: labelProps,
        wrapperProps: wrapperProps,
        containerProps: containerProps,
        helperTextTypographyProps: helperTextTypographyProps,
        noOptionsText: 'Nenhuma opção encontrada',
        dropdownProps: {
            containerProps: dropdownContainerProps,
            itemProps: dropdownItemProps,
            itemTypographyProps: dropdownItemTypographyProps,
            sectionProps: dropdownSectionProps,
            sectionTypographyProps: dropdownSectionTypographyProps,
        },
    };
};
export var buildSelectProps = function (devProps, theme) {
    var _a, _b, _c, _d;
    var multiSelect = devProps.multiSelect || false;
    var defaultProps = builderDefaultProps(theme, multiSelect);
    return buildDevProps(defaultProps, devProps &&
        __assign(__assign({}, devProps), { wrapperProps: __assign(__assign({ bColor: (devProps === null || devProps === void 0 ? void 0 : devProps.hasError)
                    ? theme.brand.color.negative.pure
                    : (_a = devProps === null || devProps === void 0 ? void 0 : devProps.wrapperProps) === null || _a === void 0 ? void 0 : _a.bColor }, devProps === null || devProps === void 0 ? void 0 : devProps.wrapperProps), { bRadius: ((_b = devProps === null || devProps === void 0 ? void 0 : devProps.wrapperProps) === null || _b === void 0 ? void 0 : _b.bRadius) ||
                    ((_c = defaultProps.wrapperProps) === null || _c === void 0 ? void 0 : _c.bRadius) }), helperTextTypographyProps: {
                color: (devProps === null || devProps === void 0 ? void 0 : devProps.hasError)
                    ? theme.brand.color.negative.pure
                    : (_d = devProps === null || devProps === void 0 ? void 0 : devProps.helperTextTypographyProps) === null || _d === void 0 ? void 0 : _d.color,
            } }));
};
